<template>
  <div class="value-range-edit-card" :class="{'top-layout': horizontal}">
    <v-card :flat="horizontal" class="rounded-0">
      <v-card-text>
        <h3 class="mb-4">Criteria Ranges</h3>
        <div>
          <v-combobox
            v-model="selectedCriteria"
            :items="criteriaList"
            item-text="name"
            item-value="id"
            :disabled="saving"
            :readonly="readonly"
            dense
            label="Select criteria"
            multiple
            @change="selectedCriteriaChanged"
          >
          </v-combobox>
        </div>
        <div>
          <div v-for="(criteriaItem, index) in selectedCriteria" :key="index">
            <div class="criteria-range-title">{{ criteriaItem.name }}</div>
            <div class="d-flex justify-space-between">
              <v-text-field v-if="editRanges[criteriaItem.id]"
                v-model="editRanges[criteriaItem.id].min"
                label="Min"
                type="number"
                small
                :disabled="saving"
                :readonly="readonly"
                @change="valueRangeChanged"
              />
              <v-text-field v-if="editRanges[criteriaItem.id]"
                v-model="editRanges[criteriaItem.id].max"
                label="Max"
                type="number"
                :disabled="saving"
                :readonly="readonly"
                small
                @change="valueRangeChanged"
              />
            </div>
          </div>
        </div>
        <div v-if="editorDirty">
          <v-btn
            small
            light
            :disabled="!editorDirty"
            @click="saveDecisionCriteriaValueRanges"
          >
            Save
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

import { mapState, mapGetters } from 'vuex'

export default {
  name: 'CriteriaRangeEditor',
  props: {
    // decisionId: String,
    // criteria: Array,
    value: Object,
    horizontal: Boolean,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editorDirty: false,
      selectedCriteria: [],
      saving: false,
      editRanges: {}
    }
  },
  mounted: function () {
    this.resetRanges()
  },
  computed: {
    ...mapState({
      decisionId: state => state.decision.decisionId
    }),
    ...mapGetters('decision',{
      criteria: 'criteriaList'
    }),
    ranges: {
      // getter
      get: function () {
        return this.value || {}
      },
      // setter
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
    criteriaList () {
      let res = []
      if (this.criteria) {
        res = this.criteria.filter(item => !item.keywordOnly)
      }
      return res
    }
  },
  methods: {
    selectedCriteriaChanged: function () {
      this.editorDirty = true
      this.criteriaList.forEach((criteriaItem) => {
        const selected = this.selectedCriteria.find(element => element.id === criteriaItem.id)
        // Add empty ranges for selected items with no range yet
        if (selected && !this.editRanges[criteriaItem.id]) {
          this.editRanges[criteriaItem.id] = {min: 0, max: 100}
        } else if (!selected && this.editRanges[criteriaItem.id]) {
          delete this.editRanges[criteriaItem.id]
        }
      })
    },
    valueRangeChanged: function () {
      this.editorDirty = true
    },
    resetRanges: function () {
      this.selectedCriteria = []
      this.editRanges = {...this.ranges}
      this.criteriaList.forEach(item => {
        if (this.editRanges[item.id]) {
          this.selectedCriteria.push(item)
        }
      })
      this.editorDirty = false
    },
    saveDecisionCriteriaValueRanges: async function () {
      this.saving = true

      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      let criteriaSuggestionsURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/criteria/ranges`
      await axios.post(criteriaSuggestionsURL, {ranges: this.editRanges}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      this.ranges = Object.assign({}, this.editRanges)
      this.saving = false
      this.editorDirty = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .value-range-edit-card {
    margin-top: 70px;

    &.top-layout {
      margin-top: 0px;
    }
  }
  .criteria-range-title {
    font-weight: 700;
  }
</style>
